import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { TranslationsContext } from '../../../config/translations';
import { cancelLabel, clearLabel, localeMap } from '../../../utils/datefns-locale';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  regularTimePickerWrapper: {
    '& div.Mui-error > input': {
      padding: 0,
    },
    '& p.Mui-error': {
      margin: theme.spacing(0, 0, 0, 1),
    },
  },
}));

const CommonTimePicker = ({ label, form, field }) => {
  const classes = useStyles();
  
  return (
    <TranslationsContext.Consumer>
      {({ languageState }) =>
        <div className={`${classes.regularTimePickerWrapper}} regularTimePickerWrapper`}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[languageState]}>
            <KeyboardTimePicker
              clearable
              ampm={false}
              format="HH:mm"
              views={['hours', 'minutes']}
              label={label}
              value={field.value ? field.value : null}
              onError={(error) => {
                if (error && form.errors && !form.errors[field.name]) {
                  form.setFieldError(field.name, error);
                }
                if (!error && form.errors && form.errors[field.name]) {
                  form.setFieldError(field.name, undefined);
                }
              }}
              onChange={(time) => {
                form.setFieldValue(field.name, time ? time : null);
              }}
              cancelLabel={cancelLabel}
              clearLabel={clearLabel}
            />
          </MuiPickersUtilsProvider>
        </div>
      }
    </TranslationsContext.Consumer>
  );
};

CommonTimePicker.propTypes = {
  label: PropTypes.object,
  form: PropTypes.object,
  field: PropTypes.object,
};

export default CommonTimePicker;
